import { render, staticRenderFns } from "./CardMerkPers.vue?vue&type=template&id=0221c266&scoped=true"
import script from "./CardMerkPers.vue?vue&type=script&lang=js"
export * from "./CardMerkPers.vue?vue&type=script&lang=js"
import style0 from "./CardMerkPers.vue?vue&type=style&index=0&id=0221c266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221c266",
  null
  
)

export default component.exports